import {
  Award,
  Banknote,
  CheckCircle,
  Clock,
  Download,
  Shield,
} from "lucide-react";
// import headerLog from "../../../RichImages/mobile.gif";
import headerLog from "../../../RichImages/app-video.mp4";
import { downloadAPK } from "../../Helpers/DownloadAPK";

// import backgroundLog from "../../../RichImages/hero-background.png";

export default function Section4() {
  const downloadApp = () => {
    console.log("Download app");
  };

  const download = async (e) => {
  e.preventDefault();

  const newTab = window.open("about:blank", "_blank");

  if (!newTab) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  // Only favicon loader (tab ke upar spinner)
  const loaderIcon =
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='40' stroke='%23999' stroke-width='8' fill='none' stroke-dasharray='180'><animateTransform attributeName='transform' type='rotate' from='0 50 50' to='360 50 50' dur='1s' repeatCount='indefinite'/></circle></svg>";

  try {
    // Empty page
    newTab.document.open();
    newTab.document.write("<html><head></head><body></body></html>");
    newTab.document.close();

    // Set favicon (THIS IS YOUR “EARTH ICON LOADER”)
    const link = newTab.document.createElement("link");
    link.rel = "icon";
    link.href = loaderIcon;
    newTab.document.head.appendChild(link);

    newTab.document.title = "Loading...";

    const url = await downloadAPK();

    if (!url) {
      newTab.close();
      return;
    }

    // start download (no redirect flicker)
    const a = document.createElement("a");
    a.href = url;
    a.download = "boss555.apk";
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => {
      newTab.close();
    }, 1500);
  } catch (err) {
    newTab.close();
    console.error(err);
  }
};

  return (
    <div className="tw-w-full">
      {/* HERO SECTION */}
      <div
        className="tw-relative tw-overflow-hidden tw-bg-cover tw-bg-center tw-bg-[#1e6ebe]"
      // style={{ backgroundImage: `url(${backgroundLog})` }}
      >
        <div className="tw-mx-auto tw-px-4 md:tw-px-8 lg:tw-px-12 tw-py-14 tw-relative tw-z-10">
          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-12 tw-items-center tw-min-h-[70vh]">
            {/* CONTENT */}
            <div className="tw-space-y-6 tw-order-1">
              <p className="tw-inline-block tw-bg-white/15 tw-text-[#EFFFFD] tw-text-[13px] md:tw-text-[16px] tw-tw-font-semibold tw-tracking-widest tw-uppercase tw-px-4 tw-py-1.5 tw-rounded-full tw-containermb-4">
                Welcome To Laksh365
              </p>

              <h1 className="tw-text-3xl md:tw-text-4xl tw-font-bold tw-text-white tw-leading-tight tw-max-w-md">
                Download The <br />
                <span className="tw-text-yellow-400">Laksh365</span> App
              </h1>

              <p className="tw-text-white tw-text-sm md:tw-text-base tw-leading-relaxed tw-max-w-lg">
                Get Instant Access To Live Results, Play Your Favorite Markets,
                And Withdraw Winnings Directly To Your Bank Account.
                <br />
                Available For Android Devices
              </p>

              {/* FEATURES LIST */}
              <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-3 tw-pt-2">
                {[
                  "Real-Time Live Results",
                  "Best Market Rates Guaranteed",
                  "Secure & Encrypted",
                  "Instant Bank Withdrawals",
                ].map((item, i) => (
                  <div key={i} className="tw-flex tw-items-center tw-gap-2">
                    <CheckCircle size={16} className="tw-text-white" />
                    <span className="tw-text-white tw-text-sm">{item}</span>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <div className="tw-flex tw-gap-3 tw-flex-nowrap lg:tw-flex-wrap">
                {/* Download App */}
                <button
                  onClick={download}
                  className="
      download-btn
      tw-flex-1
      tw-bg-yellow-400 tw-text-gray-900
      tw-px-3 tw-py-3 tw-rounded-xl
      tw-text-xs sm:tw-text-sm
      tw-font-semibold
      tw-flex tw-items-center tw-justify-center tw-gap-2
      tw-shadow-lg
      tw-transition-all tw-duration-300
      hover:tw-scale-105 hover:tw-shadow-2xl
      tw-whitespace-nowrap
    "
                >
                  <Download className="tw-animate-bounce" size={16} />
                  Download App
                </button>

                {/* Safe Download */}
                <button
                  onClick={download}
                  className="
      download-btn
      tw-flex-1
      tw-bg-[#1e6ebe] tw-text-white
      tw-px-3 tw-py-3 tw-rounded-xl
      tw-text-xs sm:tw-text-sm
      tw-font-semibold
      tw-flex tw-items-center tw-justify-center tw-gap-2
      tw-shadow-lg
      tw-transition-all tw-duration-300
      hover:tw-scale-105 hover:tw-shadow-2xl
      hover:tw-brightness-110
      tw-whitespace-nowrap
    "
                >
                  <Download className="tw-animate-bounce" size={16} />
                  Safe Download
                </button>
              </div>
            </div>

            {/* IMAGE / MOCKUP */}
            <div className="tw-flex tw-justify-center lg:tw-justify-center tw-order-2">
              <div className="tw-relative">
                {/* PHONE SHELL */}
                <div className="tw-relative tw-w-[260px] tw-h-[520px] tw-bg-gray-900 tw-rounded-[3rem] tw-border-[8px] tw-border-gray-800 tw-shadow-2xl tw-ring-4 tw-ring-gray-700">
                  {/* SCREEN CONTAINER */}
                  <div className="tw-absolute tw-inset-1 tw-bg-white tw-rounded-[2.2rem] tw-overflow-hidden tw-z-0">
                    {/* Image/GIF - Yahan 'object-cover' use kiya hai taaki gap na dikhe */}
                    <video
                      src={headerLog}  // Yahan aapka video file (mp4/webm) aayega
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="tw-w-full tw-h-full tw-object-cover tw-object-center"
                    />
                  </div>

                  {/* DYNAMIC ISLAND / NOTCH */}
                  <div className="tw-absolute tw-top-2 tw-left-1/2 tw--translate-x-1/2 tw-w-24 tw-h-6 tw-bg-black tw-rounded-full tw-z-20 tw-flex tw-items-center tw-justify-center">
                    {/* Speaker Grill Tiny Detail */}
                    <div className="tw-w-8 tw-h-1 tw-bg-gray-800 tw-rounded-full"></div>
                  </div>

                  {/* SIDE BUTTONS (For extra realism) */}
                  <div className="tw-absolute tw--right-[10px] tw-top-24 tw-w-1 tw-h-12 tw-bg-gray-800 tw-rounded-r-md"></div>
                  <div className="tw-absolute tw--left-[10px] tw-top-20 tw-w-1 tw-h-8 tw-bg-gray-800 tw-rounded-l-md"></div>

                  {/* HOME INDICATOR */}
                  <div className="tw-absolute tw-bottom-2 tw-left-1/2 tw--translate-x-1/2 tw-w-20 tw-h-1.5 tw-bg-white/30 tw-backdrop-blur-md tw-rounded-full tw-z-20"></div>
                </div>

                {/* GLOW - Slightly wider for better effect */}
                <div className="tw-absolute tw-inset-[-20px] tw-bg-teal-400/10 tw-blur-3xl tw--z-10"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TRUSTED PLATFORM */}
      <div className="tw-pt-16 tw-px-4 md:tw-px-8 lg:tw-px-12">
        <div className="tw-max-w-7xl tw-mx-auto">
          {/* HEADING */}
          <div className="tw-mb-12">
            <h2 className="tw-text-3xl lg:tw-text-4xl tw-font-bold tw-text-gray-900">
              India's Most <span className="tw-text-[#1e6ebe]">Trusted</span>
            </h2>
            <h2 className="tw-text-3xl lg:tw-text-4xl tw-font-bold tw-text-[#1e6ebe]">
              Matka <span className="tw-text-gray-900">Platform</span>
            </h2>
          </div>

          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-12 tw-mb-16">
            {/* LEFT CONTENT */}
            <div className="tw-space-y-6 tw-max-w-xl">
              <p className="tw-text-gray-600 tw-leading-relaxed">
                <span className="tw-font-semibold tw-text-gray-800">
                  Laksh365
                </span>{" "}
                has been serving players across India since 2019, delivering a
                secure, fair and transparent gaming platform.
              </p>

              <p className="tw-text-gray-600 tw-leading-relaxed">
                Best market rates, instant payouts and 24/7 customer support —
                your trust and security always come first.
              </p>

              {/* STATS */}
              <div className="tw-grid tw-grid-cols-3 tw-gap-4 tw-pt-4">
                {[
                  { value: "50K+", label: "Active Users", color: "blue" },
                  { value: "₹5Cr+", label: "Paid Out", color: "red" },
                  { value: "4.8★", label: "Rating", color: "green" },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="tw-bg-gray-50 tw-rounded-xl tw-p-4
                         tw-text-center"
                  >
                    <div
                      className={`tw-text-2xl tw-font-bold tw-text-${item.color}-600`}
                    >
                      {item.value}
                    </div>
                    <div className="tw-text-xs tw-text-gray-600 tw-mt-1">
                      {item.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* FEATURES */}
            <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-6">
              {[
                { icon: Shield, title: "100% Secure Platform", bg: "green" },
                { icon: Award, title: "Licensed & Regulated", bg: "pink" },
                { icon: Clock, title: "24/7 Support", bg: "purple" },
                { icon: Banknote, title: "Instant Payouts", bg: "yellow" },
              ].map((item, i) => (
                <div
                  key={i}
                  className="tw-bg-white tw-rounded-2xl tw-p-5
                       tw-shadow-sm hover:tw-shadow-md
                       tw-transition-all"
                >
                  <div
                    className={`tw-w-12 tw-h-12 tw-rounded-xl
                          tw-flex tw-items-center tw-justify-center
                          tw-mb-4
                          tw-bg-${item.bg}-100 tw-text-${item.bg}-600`}
                  >
                    <item.icon size={22} />
                  </div>

                  <h3 className="tw-font-semibold tw-text-gray-900 tw-mb-2">
                    {item.title}
                  </h3>

                  <p className="tw-text-sm tw-text-gray-600">
                    Trusted by thousands of players across India with guaranteed
                    safety.
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
